import React, { useEffect, useState } from 'react'
import { PAYMENT_TYPE, VIEW } from '../../constant'
import { IconCheckoutCreditCard } from '../common/Icons'
import BasicRadio from '../ui/BasicRadio'
import api from '../../api'
// eslint-disable-next-line
import { Elements, CardElement, ElementsConsumer } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
import BasicButton from '../ui/BasicButton'
import PayWithCreditCard from '../checkout/PayWithCreditCard'
import { useAppDispatch, useAppSelector } from '../../redux/hooks'
import {
  setCryptoPayment,
  // eslint-disable-next-line
  setIsFinishCreditCard,
  // eslint-disable-next-line
  setIsFinishCrypto,
  setIsFinishGuestInfo,
  setToastError,
} from '../../redux/slices/common'
import { convertChainIdToNumber, renderDates } from '../../utils'
import moment from 'moment/moment'
// import PriceBreakDown from '../checkout/PriceBreakDown'
import { BookingDataProps, GuestInfoProps } from '../../interfaces'
import CheckboxConfirmBooking from '../checkout/CheckboxConfirmBooking'
import clsx from 'clsx'
import SelectContactInfo from './SelectContactInfo'
import { createReservation, getPaymentMethod, getPricesBooking, stripePaymentBooking } from '../../api/common'
import {
  setIsBookingSuccess,
  setReservationId,
  setGuestInfo as setGuestInfoRedux,
  setIsBookingAvail,
  setBookingPrices,
} from '../../redux/slices/property'
import PayWithCryptoContainer from '../checkout/PayWithCryptoContainer'
import { isEmpty } from '../../utils'
import { ethers } from 'ethers'
import { PROPERTY_CONTRACT_ABI, TOKEN_CONTRACT_ABI } from '../../utils/abi'
import RenderPrice from '../common/RenderPrice'

interface Props {
  hostId: string
  propertyId?: string
  updateView: (_v: string) => void
}
// const currency = 'USD'
const SelectPayments: React.FC<Props> = ({ hostId, updateView }) => {
  const dispatch = useAppDispatch()
  const { isLayoutHasScroll } = useAppSelector((state) => state.common)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [paymentType, setPaymentType] = useState<string>('')
  const [stripeInfo, setStripeInfo] = useState<any>(null)
  const [paymentMethods, setPaymentMethods] = useState<Array<any>>([])
  const {
    isFinishCreditCard,
    isFinishCrypto,
    isFinishGuestInfo,
    cryptoPayment,
    accounts,
    tokenContract,
    chainId,
    stripeComplete,
  } = useAppSelector((state) => state.common)
  const { adults, children, infants, pets, checkIn, checkOut, listingData, bookingPrices, promoCode } = useAppSelector(
    (state) => state.property
  )
  const currency = listingData?.propertyPrice?.currency
  const [nights, setNights] = useState<number>(1)
  const [guestInfo, setGuestInfo] = useState<GuestInfoProps>({})
  const [isDisabledByContact, setIsDisabledByContact] = useState<boolean>(false)
  const [isCheckedConditions, setCheckedConditions] = useState<boolean>(false)
  const isCryptoPayment = paymentType === PAYMENT_TYPE.CRYPTO
  const currencySelected = isCryptoPayment ? cryptoPayment : currency
  const finalPrice = bookingPrices?.finalPrice[currencySelected]
  const paymentMethodCrypto: Array<any> = paymentMethods.filter((v) => v.type === 'CRYPTO') || []
  const paymentMethodFiat: Array<any> = paymentMethods.find((v) => v.type === 'STRIPE') || []

  console.log('--isLayoutHasScroll--', isLayoutHasScroll)

  useEffect(() => {
    const checkInDate = moment(checkIn, 'YYYY-MM-DD')
    const checkOutDate = moment(checkOut, 'YYYY-MM-DD')
    const diffDays = checkOutDate.diff(checkInDate, 'days')
    setNights(diffDays)
  }, [checkIn, checkOut])

  async function fetchPricesBooking() {
    if (checkIn && checkOut) {
      try {
        dispatch(setIsBookingAvail(true))
        setIsLoading(true)
        const res: any = await getPricesBooking({
          checkinDate: checkIn,
          checkoutDate: checkOut,
          adults: adults,
          children: children,
          infants: infants,
          pets: pets,
          listingId: listingData.id,
          currency: cryptoPayment || currency,
          promoCode: promoCode,
        })
        if (res.success) {
          const isAvail = res.data?.isAvail
          dispatch(setBookingPrices(res.data))
          dispatch(setIsBookingAvail(isAvail))
        }
      } catch (error: any) {
        dispatch(setToastError({ message: error.error.message }))
      } finally {
        setIsLoading(false)
      }
    }
  }

  useEffect(() => {
    fetchPricesBooking()
  }, [checkIn, checkOut, adults, children, infants, pets, listingData?.id, currency, promoCode, cryptoPayment])

  useEffect(() => {
    if (!isEmpty(paymentMethods) && !isEmpty(listingData)) {
      if (!isEmpty(paymentMethodFiat) && listingData?.fiatPaymentEnabled) setPaymentType(PAYMENT_TYPE.FIAT)
      else if (!isEmpty(paymentMethodCrypto) && listingData?.cryptoPaymentEnabled) setPaymentType(PAYMENT_TYPE.CRYPTO)
    }
  }, [paymentMethods, listingData])

  useEffect(() => {
    const fetchStripeInfo = async () => {
      try {
        const params: any = { hostAddress: hostId }
        const stripeAccountId = listingData?.stripeAccountId
        if (stripeAccountId) {
          params.id = stripeAccountId
        }
        const res: any = await api.get('/paygate-service/stripe/info', {
          params: params,
        })
        if (res.success) {
          setStripeInfo(res.data)
        }
      } catch (error) {
        console.log('--fetchStripeInfo error--:', error)
      }
    }
    const fetchPaymentMethod = async () => {
      try {
        const res: any = await getPaymentMethod(hostId)
        if (res.success) {
          setPaymentMethods(res.data)
        }
      } catch (error) {
        console.log(error)
      }
    }
    if (hostId && listingData?.id) {
      fetchStripeInfo()
      fetchPaymentMethod()
    }
  }, [hostId, listingData])

  const handleUpdateGuestInfo = (newGuestInfo: GuestInfoProps) => {
    setGuestInfo((prevState) => ({ ...prevState, ...newGuestInfo }))
  }

  const handleUpdateIsDisabledByContact = (_isDisabled: boolean) => {
    setIsDisabledByContact(_isDisabled)
  }

  const onSelectPaymentType = (type: string) => {
    setPaymentType(type)
  }

  const toggleCheckedConditions = () => {
    setCheckedConditions((prevState) => !prevState)
  }

  const handleNext = () => {
    dispatch(setIsFinishGuestInfo(true))
    // if (isCryptoPayment) dispatch(setIsFinishCrypto(true))
    // else dispatch(setIsFinishCreditCard(true))
  }
  const showError = (errMessage: string) => {
    if (errMessage) dispatch(setToastError({ message: errMessage }))
  }

  const handlePaymentWithCrypto = async (bookingData: any, tokenAddress: string, setLoading: any) => {
    // const maxNumber = BigNumber.from('0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff') // 2^256 - 1
    const isNeedApproved = !tokenAddress?.startsWith('0x0') // native coin
    try {
      const { reservationId, guestWallet, currencyAddress } = bookingData as any
      const { payments, paymentId, finalPrice, paymentContract } = bookingData?.paymentInfo as any
      // amount: utils.parseUnits(String(bookingAmount), decimal)

      const provider = new ethers.providers.Web3Provider((window as any)?.ethereum)
      let baseNonce = provider.getTransactionCount(guestWallet)
      let nonceOffset = 0
      const getNonce = () => {
        return baseNonce.then((nonce: any) => nonce + nonceOffset++)
      }
      const signer = provider.getSigner(guestWallet)
      const contract = new ethers.Contract(currencyAddress, TOKEN_CONTRACT_ABI, signer)

      if (isNeedApproved) {
        // book with bsc network
        await contract.approve(paymentContract, finalPrice, {
          nonce: getNonce(),
        })
        contract.on('Approval', async (from, to) => {
          // console.log('approval event from', from, guestWallet)
          // console.log('approval event to', to)
          // console.log('approval event amount', amount)
          const isSuccess =
            from.toLowerCase() === guestWallet.toLowerCase() &&
            String(to).toLowerCase() === paymentContract.toLowerCase()
          if (isSuccess) {
            contract.removeAllListeners('Approval')
            // handle payment
            const newContract = new ethers.Contract(paymentContract, PROPERTY_CONTRACT_ABI, signer)
            const book = await newContract
              .makePayment(paymentId, payments, { value: 0, nonce: getNonce(), gasLimit: 5000000 })
              .catch((err: any) => {
                setLoading(false)
                dispatch(setToastError({ message: err?.data?.message || err?.message }))
              })
            setLoading(false)

            if (book) {
              dispatch(setReservationId(reservationId))
              updateView(VIEW.BOOKING_SUCCESSED)
              dispatch(setIsBookingSuccess(true))
              dispatch(setGuestInfoRedux(guestInfo))
            }
          }
        })
      } else {
        // book with native token
        const newContract = new ethers.Contract(paymentContract, PROPERTY_CONTRACT_ABI, signer)
        const book = await newContract
          .makePayment(paymentId, payments, { value: finalPrice, nonce: getNonce(), gasLimit: 5000000 })
          .catch((err: any) => {
            setLoading(false)
            dispatch(setToastError({ message: err?.data?.message || err?.message }))
          })
        setLoading(false)
        if (book) {
          dispatch(setReservationId(reservationId))
          updateView(VIEW.BOOKING_SUCCESSED)
          dispatch(setIsBookingSuccess(true))
          dispatch(setGuestInfoRedux(guestInfo))
        }
      }
    } catch (error: any) {
      setLoading(false)
      dispatch(setToastError({ message: error?.data?.message || error?.message }))
    }
  }
  const handleCompleteBooking = async (stripe: any, elements: any) => {
    if (!checkIn || !checkOut) {
      return
    }
    try {
      setIsLoading(true)
      let bodyData: BookingDataProps = {
        checkinDate: checkIn,
        checkoutDate: checkOut,
        guestCount: 1,
        adults: adults,
        children: children,
        infants: infants,
        pets: pets,
        listingId: listingData.id,
        guestInfo: {
          ...guestInfo,
          name: `${guestInfo.firstName} ${guestInfo.lastName}`,
        },
        finalPrice: finalPrice,
        paymentMethod: paymentType,
        currency: currencySelected,
        utmSource: 'sdk',
      }
      if (!isEmpty(promoCode)) bodyData.promoCode = promoCode
      if (isCryptoPayment) {
        const tokenActive = tokenContract.find((v: any) => v.symbol === cryptoPayment)
        bodyData = {
          ...bodyData,
          guestWallet: accounts[0],
          chainId: convertChainIdToNumber(chainId),
          currencyAddress: tokenActive?.address || '',
        }
      }
      const res = await createReservation(bodyData)
      const reserId = res.data.reservationId
      dispatch(setReservationId(reserId))
      if (isCryptoPayment) {
        const tokenActive = tokenContract.find((v: any) => v.symbol === cryptoPayment)
        // payment with crypto
        handlePaymentWithCrypto(res?.data, tokenActive?.address || '', setIsLoading)
      } else {
        await handlePaymentIntent(reserId, stripe, elements)
      }
    } catch (error: any) {
      console.log('--er--', error)
      showError(
        error ? error?.error?.message : 'Please wait while we’re processing your payment of another transaction.'
      )
      setIsLoading(false)
    } finally {
      // setIsLoading(false)
    }
  }

  const handlePaymentIntent = async (reservationId: string, stripe: any, elements: any) => {
    try {
      const res: any = await stripePaymentBooking(reservationId)
      if (res.success) {
        if (res.data?.paymentIntent?.status === 'succeeded') {
          // manual reservation 0đ
          // dispatch(setToastSuccess({ message: 'Payment succeeded' }))
          console.log('Payment succeeded, go to reservation detail')
          dispatch(setIsBookingSuccess(true))
          dispatch(setGuestInfoRedux(guestInfo))
          // updateView
          updateView(VIEW.BOOKING_SUCCESSED)
        } else {
          const cardElement = elements.getElement(CardElement)
          let result = await stripe.confirmCardPayment(res.data.paymentIntent?.client_secret, {
            payment_method: { card: cardElement },
          })
          if (result.error) {
            showError(
              result?.error?.payment_intent?.last_payment_error?.message ||
                result?.error?.message ||
                result?.data?.message
            )
          } else {
            console.log('Payment succeeded, go to reservation detail')
            dispatch(setIsBookingSuccess(true))
            dispatch(setGuestInfoRedux(guestInfo))
            updateView(VIEW.BOOKING_SUCCESSED)
          }
          setIsLoading(false)
        }
      }
    } catch (error: any) {
      setIsLoading(false)
      dispatch(setIsBookingSuccess(false))
    }
  }

  if (!hostId) {
    return null
  }

  // eslint-disable-next-line
  const isFinishPaymentMethod = isCryptoPayment ? isFinishCrypto : isFinishCreditCard

  return (
    <Elements
      stripe={loadStripe(stripeInfo?.stripePublishableKey || '', {
        locale: 'en',
        stripeAccount: stripeInfo?.stripeAccount,
      })}
    >
      <ElementsConsumer>
        {({ stripe, elements }) => {
          return (
            <>
              {/*---Select payment: Credit card---*/}
              <div className={`${isFinishGuestInfo ? '' : 'hidden'} mb-[24px]`}>
                <p className={'dtravel-inter-500 dtravel-text-14-20 dtravel-neutral-900 mb-[12px]'}>
                  Select a payment method:
                </p>
                {!isEmpty(paymentMethodFiat) && listingData?.fiatPaymentEnabled && (
                  <label
                    className={clsx(
                      'dtravel-flex-between items-center gap-[32px] dtravel-rounded-16 cursor-pointer p-[16px] mb-4',
                      {
                        'border-[2px] border-grayscale-800': paymentType === PAYMENT_TYPE.FIAT,
                        'border border-grayscale-300': paymentType !== PAYMENT_TYPE.FIAT,
                      }
                    )}
                    htmlFor={'payment_fiat'}
                  >
                    <div className={'flex dtravel-flex-col dtravel-gap-8'}>
                      <span
                        className={`px-[8px] pt-[2px] pb-[1px] dtravel-inter-600 dtravel-text-14-20 dtravel-neutral-900`}
                      >
                        Credit card
                      </span>
                      <span className={'dtravel-inter-400 dtravel-text-14-18 dtravel-neutral-800'}>
                        <IconCheckoutCreditCard />
                      </span>
                    </div>
                    <BasicRadio
                      id={'payment_fiat'}
                      type={'radio'}
                      classes={'w-[24px] h-[24px] cursor-pointer'}
                      name={`property_status`}
                      value={PAYMENT_TYPE.FIAT}
                      checked={paymentType === PAYMENT_TYPE.FIAT}
                      onChange={(event) => {
                        onSelectPaymentType(event.target.value)
                        dispatch(setCryptoPayment(''))
                      }}
                    />
                  </label>
                )}
                {!isEmpty(paymentMethodCrypto) && listingData?.cryptoPaymentEnabled && (
                  <label
                    className={clsx(
                      'dtravel-flex-between items-center gap-[32px] dtravel-rounded-16 cursor-pointer p-[16px] mb-4',
                      {
                        'border-[2px] border-grayscale-800': paymentType === PAYMENT_TYPE.CRYPTO,
                        'border border-grayscale-300': paymentType !== PAYMENT_TYPE.CRYPTO,
                      }
                    )}
                    htmlFor={'payment_crypto'}
                  >
                    <div className={'flex dtravel-flex-col dtravel-gap-8'}>
                      <span
                        className={`px-[8px] pt-[2px] pb-[1px] dtravel-inter-600 dtravel-text-14-20 dtravel-neutral-900`}
                      >
                        Crypto
                      </span>
                      <div className="flex items-center gap-[8px]">
                        {paymentMethodCrypto.map((el: any) => (
                          <span className="flex items-center" key={el.key}>
                            <img src={el.icon} alt="" width={24} height={24} />
                          </span>
                        ))}
                      </div>
                    </div>
                    <BasicRadio
                      id={'payment_crypto'}
                      type={'radio'}
                      classes={'w-[24px] h-[24px] cursor-pointer'}
                      name={`property_status`}
                      value={PAYMENT_TYPE.CRYPTO}
                      checked={paymentType === PAYMENT_TYPE.CRYPTO}
                      onChange={(event) => {
                        onSelectPaymentType(event.target.value)
                      }}
                    />
                  </label>
                )}
                <div className={`mt-[24px] ${paymentType === PAYMENT_TYPE.FIAT ? 'block' : 'hidden'}`}>
                  <PayWithCreditCard />
                </div>
                {paymentType === PAYMENT_TYPE.CRYPTO && !isEmpty(paymentMethodCrypto) && (
                  <div style={{ marginTop: 24 }}>
                    <PayWithCryptoContainer paymentMethods={paymentMethods} bookingPrices={bookingPrices} />
                  </div>
                )}
              </div>

              {/*---Update contact info---*/}
              <div className={`${isFinishGuestInfo ? 'hidden' : ''} flex dtravel-flex-col dtravel-gap-24 mb-[24px]`}>
                <div className={'dtravel-w-full p-[16px] bg-grayscale-100 dtravel-rounded-12 dtravel-flex-between'}>
                  <p className={''}>
                    {renderDates(checkIn, checkOut)} ({nights} {nights > 1 ? 'nights' : 'night'} )
                  </p>
                  <span>
                    <RenderPrice price={bookingPrices?.finalPrice?.[currencySelected]} currency={currencySelected} />
                  </span>
                  {/*<div className={''}>*/}
                  {/*  {bookingPrices && bookingPrices.exchangeRate && (*/}
                  {/*    <PriceBreakDown data={bookingPrices} currency={currencySelected} nights={nights} />*/}
                  {/*  )}*/}
                  {/*</div>*/}
                </div>
                {(paymentType === PAYMENT_TYPE.FIAT || paymentType === PAYMENT_TYPE.CRYPTO) && (
                  <SelectContactInfo
                    guestInfo={guestInfo}
                    handleUpdateGuestInfo={handleUpdateGuestInfo}
                    handleUpdateIsDisabled={handleUpdateIsDisabledByContact}
                  />
                )}
                <div className={'h-[102px]'} />
              </div>

              {isFinishGuestInfo ? (
                <div
                  className={clsx('px-[24px] py-[16px] bg-white shadow-xl', {
                    // 'dtravel-absolute bottom-0 left-0 dtravel-w-full': !isLayoutHasScroll,
                    // 'sticky bottom-[-24px] left-0 !w-[calc(100%+48px)] ml-[-24px] mb-[-24px]': isLayoutHasScroll,
                    'sticky bottom-[-24px] left-0 !w-[calc(100%+48px)] ml-[-24px] mb-[-24px]': true,
                  })}
                  style={{ zIndex: 1200 }}
                >
                  <div className={'flex dtravel-flex-col gap-[16px]'}>
                    <CheckboxConfirmBooking
                      hostId={hostId}
                      listingData={listingData}
                      isChecked={isCheckedConditions}
                      toggleChecked={toggleCheckedConditions}
                    />
                    <BasicButton
                      variant={'contained'}
                      color={'black'}
                      clases={'dtravel-w-full'}
                      size={'lg'}
                      onClick={() => handleCompleteBooking(stripe, elements)}
                      loading={isLoading}
                      disabled={
                        !isCheckedConditions ||
                        isDisabledByContact ||
                        // !finalPrice ||
                        (paymentType === PAYMENT_TYPE.CRYPTO && isEmpty(cryptoPayment)) ||
                        !bookingPrices.isAvail ||
                        (paymentType === PAYMENT_TYPE.FIAT && !stripeComplete)
                      }
                    >
                      Complete booking
                    </BasicButton>
                  </div>
                </div>
              ) : (
                <div
                  // className={clsx(
                  //   'sticky bottom-[-24px] left-0 !w-[calc(100%+48px)] h-[72px] shadow-xl bg-white',
                  //   'px-[24px] py-[16px] ml-[-24px] mb-[-24px]',
                  //   'flex dtravel-gap-8 justify-end'
                  // )}
                  className={clsx('px-[24px] py-[16px] bg-white h-[72px] shadow-xl', {
                    // 'dtravel-absolute bottom-0 left-0 dtravel-w-full': !isLayoutHasScroll,
                    // 'sticky bottom-[-24px] left-0 !w-[calc(100%+48px)] ml-[-24px] mb-[-24px]': isLayoutHasScroll,
                    'dtravel-absolute bottom-0 left-0 dtravel-w-full': true,
                  })}
                  style={{ zIndex: 1200 }}
                >
                  <BasicButton
                    variant={'contained'}
                    color={'black'}
                    clases={'dtravel-w-full'}
                    size={'lg'}
                    onClick={handleNext}
                    disabled={isDisabledByContact}
                    // disabled={isCryptoPayment ? isEmpty(cryptoPayment) : !stripeComplete}
                  >
                    Next
                  </BasicButton>
                </div>
              )}
            </>
          )
        }}
      </ElementsConsumer>
    </Elements>
  )
}

export default SelectPayments
